export const GET_MONITOREOS_ESPECTACULARES_LOADING =
  'monitoreosEspectaculares/GET_MONITOREOS_ESPECTACULARES_LOADING';
export const GET_MONITOREOS_ESPECTACULARES_SUCCESS =
  'monitoreosEspectaculares/GET_MONITOREOS_ESPECTACULARES_SUCCESS';
export const GET_MONITOREOS_ESPECTACULARES_FAILURE =
  'monitoreosEspectaculares/GET_MONITOREOS_ESPECTACULARES_FAILURE';

export const UPSERT_MONITOREOS_ESPECTACULARES_LOADING =
  'monitoreosEspectaculares/UPSERT_MONITOREOS_ESPECTACULARES_LOADING';
export const UPSERT_MONITOREOS_ESPECTACULARES_SUCCESS =
  'monitoreosEspectaculares/UPSERT_MONITOREOS_ESPECTACULARES_SUCCESS';
export const UPSERT_MONITOREOS_ESPECTACULARES_FAILURE =
  'monitoreosEspectaculares/UPSERT_MONITOREOS_ESPECTACULARES_FAILURE';

export const GET_ESPECTACULARES_ACTA_INICIO_LOADING =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_INICIO_LOADING';
export const GET_ESPECTACULARES_ACTA_INICIO_SUCCESS =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_INICIO_SUCCESS';
export const GET_ESPECTACULARES_ACTA_INICIO_FAILURE =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_INICIO_FAILURE';

export const UPSERT_ESPECTACULARES_ACTA_INICIO_LOADING =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_INICIO_LOADING';
export const UPSERT_ESPECTACULARES_ACTA_INICIO_SUCCESS =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_INICIO_SUCCESS';
export const UPSERT_ESPECTACULARES_ACTA_INICIO_FAILURE =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_INICIO_FAILURE';

export const GET_ESPECTACULARES_ACTA_CIERRE_LOADING =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_CIERRE_LOADING';
export const GET_ESPECTACULARES_ACTA_CIERRE_SUCCESS =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_CIERRE_SUCCESS';
export const GET_ESPECTACULARES_ACTA_CIERRE_FAILURE =
  'monitoreosEspectaculares/GET_ESPECTACULARES_ACTA_CIERRE_FAILURE';

export const UPSERT_ESPECTACULARES_ACTA_CIERRE_LOADING =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_CIERRE_LOADING';
export const UPSERT_ESPECTACULARES_ACTA_CIERRE_SUCCESS =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_CIERRE_SUCCESS';
export const UPSERT_ESPECTACULARES_ACTA_CIERRE_FAILURE =
  'monitoreosEspectaculares/UPSERT_ESPECTACULARES_ACTA_CIERRE_FAILURE';
